module.exports = __webpack_public_path__ + "img/soc.a8243587.png";